

  <form *ngIf="ready$ | async" [formGroup]="form!">
    <div #formContainer>
    </div>
  <dx-text-area formControlName="name" formField required minlength="2" />
  <dx-lookup formControlName="calendarId" formField required
  [gsResource]="calendar"
  displayExpr="name"
  valueExpr="id"
  [createComponent]="createCalendarComponent"
  />
  <dx-lookup formControlName="timetableId" formField required
  [gsResource]="timetables"
  displayExpr="name"
  valueExpr="id"
  [createComponent]="createTimetableComponent"
  />
  
  <dx-lookup formControlName="projectManagerWorkerId" formField
  [gsResource]="workers"
  displayExpr="name"
  valueExpr="id"
  />
  
  <gs-address-field  formControlName="address" formField required/>

  <dx-number-box formControlName="initialBudget" formField required [format]="formatCurrency"/>
  
  <dx-text-area formControlName="comments" formField/>
  </form>